/*
@创建人: lfq
@创建时间: 2020-10-11 16:31:27
@文件介绍: 涵洞决策
*/
export default [{
    path: 'culvertMpm',
    name: 'culvertMpm',
    meta: {
        title: '涵洞规划管理',
        auth: true
    },
    component: () =>
        import ('@/views/culvertDecision/culvertMpm')
},{
    path: 'culvertMfp',
    name: 'culvertMfp',
    meta: {
        title: '涵洞养护资金规划',
        auth: true
    },
    component: () =>
        import ('@/views/culvertDecision/culvertMfp')
},{
    path: 'culvertMp',
    name: 'culvertMp',
    meta: {
        title: '涵洞养护规划',
        auth: true
    },
    component: () =>
        import ('@/views/culvertDecision/culvertMp')
}]

